import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class FeedbackToSlackTitle extends PrimitiveValueObject<string> {
  static create(value: string): FeedbackToSlackTitle {
    // if (value === null) {
    //   throw new ArgumentNullException();
    // }
    return new FeedbackToSlackTitle(value);
  }
}
